import * as React from "react";
import { makeHierarchicalLabel } from "src/business/sysData/SysParentsColumn";
import { SelectFromModalButton } from "src/components/SelectFromModalButton/SelectFromModalButton";
import { makeUrl } from "src/routes/makeUrl";
import { PageUrl } from "src/routes/PageUrl";
import { ZSidLabel, zSidLabel } from "src/types";

import { StdLink } from "../../StdLink/StdLink";
import { ZAttrClassesSelect } from "../ZAttrComponent";
import { ClassesSelectModal } from "./ClassesSelectModal";

type PropsAttrClassesSelect = {
  component: ZAttrClassesSelect;
  disabled?: boolean;
  value: unknown;
  onChange?(newValue?: unknown): void;
  onBlur(): void;
};

export const AttrClassesSelect: React.FC<PropsAttrClassesSelect> = (props) => {
  const { component, disabled, value, onChange, onBlur } = props;
  const parsedValue = zSidLabel.array().safeParse(value).data || [];
  const typedValue = parsedValue;
  const { parentsMap } = component;
  const [open, setOpen] = React.useState(false);

  const makeClassLink = React.useCallback(
    (opt: ZSidLabel) => (
      <StdLink href={makeUrl(PageUrl.class, { id: opt.id })}>
        {makeHierarchicalLabel(parentsMap[opt.id], opt.label || opt.id)}
      </StdLink>
    ),
    [parentsMap],
  );

  return (
    <SelectFromModalButton
      multi
      disabled={disabled}
      options={typedValue ?? []}
      onOpen={() => setOpen(true)}
      onChange={(newValue: ZSidLabel[] | null) => onChange?.(newValue)}
      makeTagLabel={makeClassLink}
      onBlur={onBlur}
    >
      <ClassesSelectModal
        open={open}
        close={() => setOpen(false)}
        classifier={component.classifier}
        value={typedValue ?? []}
        onChange={onChange}
        initialParents={parentsMap}
      />
    </SelectFromModalButton>
  );
};
